module.exports = __webpack_public_path__ + "img/audi1.34dc96f9.jpg";